import { deleteDB, openDB } from 'idb';

export const doDeleteDB = (dbName: string): Promise<'success'|'blocked'> =>
  new Promise<'success'|'blocked'>((res) => {
    openDB(dbName).then((db) => {
      db.close();
      deleteDB(dbName, { blocked: () => res('blocked') }).then(() => res('success'));
    });
  });
